<div class="auth-action text-center" aria-live="polite">
  @switch (view) {
    @case ('working') {
      <h2 class="action-title">One moment</h2>
      <p class="instructions">
        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
        Checking your link...
      </p>
    }

    @case ('verified') {
      <h2 class="action-title">Email verified</h2>
      <p class="instructions">
        @if (email) {
          <strong class="user-email">{{ email }}</strong> is verified.
        } @else {
          Your email address is verified.
        }
        @if (signedInAsVerifiedUser) {
          You can carry on where you left off.
        } @else {
          Sign in to continue.
        }
      </p>
      <div class="d-grid gap-2 mt-3">
        <button type="button" class="btn btn-primary btn-fill btn-danger" (click)="continue()">
          {{ signedInAsVerifiedUser ? 'Continue to Scan Ninja' : 'Sign in' }}
        </button>
      </div>
    }

    @case ('reset-form') {
      <h2 class="action-title">Choose a new password</h2>
      @if (email) {
        <p class="instructions">For <strong class="user-email">{{ email }}</strong></p>
      }
      <form [formGroup]="passwordForm" (ngSubmit)="submitNewPassword()" novalidate>
        <label class="visually-hidden" for="newPassword">New password</label>
        <input
          id="newPassword"
          class="form-control"
          type="password"
          formControlName="password"
          placeholder="New password"
          autocomplete="new-password"
        />
        <ul class="field-hint list-unstyled">
          <li [class.text-danger]="passwordError('minlength')">
            At least 15 characters. A few words strung together work well.
          </li>
        </ul>
        @if (passwordError('weak')) {
          <div class="server-error" role="alert">That password is too weak. Choose a stronger one.</div>
        }

        <label class="visually-hidden" for="confirmPassword">Confirm new password</label>
        <input
          id="confirmPassword"
          class="form-control"
          type="password"
          formControlName="confirm"
          placeholder="Confirm new password"
          autocomplete="new-password"
        />
        @if (passwordForm.hasError('mismatch') && passwordForm.get('confirm')?.dirty) {
          <div class="server-error" role="alert">The passwords do not match.</div>
        }

        <div class="d-grid gap-2 mt-3">
          <button
            type="submit"
            class="btn btn-primary btn-fill btn-danger"
            [disabled]="passwordForm.invalid || busy"
          >
            {{ busy ? 'Saving...' : 'Set new password' }}
          </button>
        </div>
      </form>
    }

    @case ('reset-done') {
      <h2 class="action-title">Password changed</h2>
      <p class="instructions">Your password has been updated. Sign in with your new password.</p>
      <div class="d-grid gap-2 mt-3">
        <a class="btn btn-primary btn-fill btn-danger" routerLink="/login" [replaceUrl]="true">Sign in</a>
      </div>
    }

    @case ('recovered') {
      <h2 class="action-title">Email restored</h2>
      <p class="instructions">
        Your sign-in email is back to
        <strong class="user-email">{{ email || 'your previous address' }}</strong>.
        If you did not ask for the change, reset your password now.
      </p>
      @if (resetLinkSent) {
        <div class="success-message" role="status">Password reset email sent. Check your inbox.</div>
      }
      @if (errorMessage) {
        <div class="server-error" role="alert">{{ errorMessage }}</div>
      }
      <div class="d-grid gap-2 mt-3">
        <button
          type="button"
          class="btn btn-primary btn-fill btn-danger"
          (click)="sendResetToRecoveredEmail()"
          [disabled]="busy || resetLinkSent || !email"
        >
          Reset my password
        </button>
        <a class="btn btn-primary btn-sm btn-fill" routerLink="/login">Sign in</a>
      </div>
    }

    @case ('email-changed') {
      <h2 class="action-title">Email updated</h2>
      <p class="instructions">
        You can now sign in with
        <strong class="user-email">{{ email || 'your new email address' }}</strong>.
      </p>
      <div class="d-grid gap-2 mt-3">
        <a class="btn btn-primary btn-fill btn-danger" routerLink="/login" [replaceUrl]="true">Sign in</a>
      </div>
    }

    @case ('error') {
      <h2 class="action-title">This link didn't work</h2>
      <div class="server-error" role="alert">{{ errorMessage }}</div>
      <div class="d-grid gap-2 mt-3">
        @if (canRetry) {
          <button type="button" class="btn btn-primary btn-fill btn-danger" (click)="retry()">Try again</button>
          <a class="btn btn-primary btn-sm btn-fill" routerLink="/login">Sign in</a>
        } @else {
          <a class="btn btn-primary btn-fill btn-danger" routerLink="/login">Sign in</a>
          <a class="btn btn-primary btn-sm btn-fill" routerLink="/reset-password">Reset password</a>
        }
      </div>
    }
  }
</div>
